import React from 'react';
import { Wrench, Sparkles } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import Services from '../components/Services';

const SCHEMA = {
  "@type": "Service",
  "serviceType": "Suporte e Terceirização de TI para Empresas",
  "provider": { "@type": "LocalBusiness", "name": "Fernando Tech", "areaServed": "Ribeirão Preto e região" },
  "areaServed": { "@type": "City", "name": "Ribeirão Preto" },
  "description": "Suporte técnico empresarial, terceirização de TI, manutenção preventiva e corretiva, redes e consultoria em Ribeirão Preto e região.",
};

const FAQ = [
  { q: "A Fernando Tech atende empresas em Ribeirão Preto e região?", a: "Sim. Atendemos presencialmente em Ribeirão Preto e cidades da região, além de suporte remoto para todo o Brasil." },
  { q: "O que inclui a terceirização de TI?", a: "Suporte a usuários, gestão de servidores e redes, backup, segurança, manutenção preventiva e consultoria — sob demanda ou em plano mensal." },
  { q: "Vocês oferecem contrato mensal de suporte?", a: "Sim. Temos planos mensais de suporte gerenciado que reduzem custos e evitam paradas na sua operação." },
  { q: "Atendem também computadores e notebooks avulsos?", a: "Sim. Fazemos manutenção e assistência técnica de PCs e notebooks para empresas e pessoas físicas." },
  { q: "Quanto custa o suporte de TI?", a: "O valor depende do tamanho da empresa e do escopo. Fale conosco para um diagnóstico e orçamento sem compromisso." },
];

export default function ServicosTiPage() {
  return (
    <SubjectPageLayout
      path="/servicos-ti"
      breadcrumbName="Serviços de TI"
      breadcrumbIcon={<Wrench className="w-3.5 h-3.5" />}
      seoTitle="Serviços de TI para Empresas | Fernando Tech — Ribeirão Preto"
      seoDescription="Suporte de TI, terceirização, manutenção preventiva e corretiva, redes e consultoria para empresas em Ribeirão Preto e região. Atendimento rápido e equipe especializada há mais de 15 anos."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Suporte Técnico Premium',
        badgeIcon: <Sparkles className="w-3.5 h-3.5" />,
        title: 'Serviços de TI',
        accent: 'para a sua empresa',
        subtitle: 'Help desk, terceirização de TI, manutenção de computadores, redes e consultoria — tudo com atendimento ágil em Ribeirão Preto e região.',
      }}
      cta={{ heading: 'Sua empresa precisa de suporte de TI?', text: 'Fale com a Fernando Tech e tenha uma equipe de TI cuidando da sua tecnologia. Diagnóstico e orçamento sem compromisso.' }}
    >
      <Services />
    </SubjectPageLayout>
  );
}
